import React, { useEffect, useState } from "react";
import styles from "./reviewProductDetailsPage.module.scss";
import ReviewProductDetails from "../../components/uiComponents/reviewProductDetails/ReviewProductDetails";
import DescriptionTile from "../../components/uiComponents/descriptionTile/DescriptionTile";
import ReviewTile from "../../components/uiComponents/reviewTile/ReviewTile";
import { useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { getReviewsByProductId } from "../../store/actions";
const ReviewProductDetailsPage = ({ reviews = [] }) => {
  const location = useLocation();
  const { product } = location.state || {};
  const [activeTab, setActiveTab] = useState("description");
  const [sortValue, setSortValue] = useState("high-to-low");
  const dispatch = useDispatch();

  useEffect(() => {
    console.log("the product is", product)
  }, [])
  useEffect(() => {
    const id = product?.productId
    dispatch(getReviewsByProductId(
      {
        id: id,
        callback: {
          success: (data) => {
            console.log("data received by callback", data)

          },
          error: (err) => {
            console.error("Error fetching data:", err);

          }
        }
      }
    ))

  }, [])
  useEffect(() => {
    console.log("review data is comming", reviews)

  }, [reviews])
  // const sortedReviews = (reviews ? [...reviews] : [])?.sort((a, b) => {
  //   if (sortValue === "high-to-low") {
  //     return b.rating - a.rating;
  //   }
  //   if (sortValue === "low-to-high") {
  //     return a.rating - b.rating;
  //   }
  //   return 0;
  // });


  return (
    <div className={styles.container}>
      <div className={styles.top}>
        <div className={styles.title}>Product Details</div>
        <ReviewProductDetails product={product} />
      </div>

      <div className={styles.bottom}>
        <div className={styles.head}>
          <div
            className={`${styles.title} ${activeTab === "description" ? styles.active : ""
              }`}
            onClick={() => setActiveTab("description")}
          >
            Description
          </div>
          <div
            className={`${styles.title} ${activeTab === "review" ? styles.active : ""
              }`}
            onClick={() => setActiveTab("review")}
          >
            Review
          </div>
        </div>

        {activeTab === "description" && <DescriptionTile product={product} />}
        {activeTab === "review" && (
          <div>
            {/* <div className={styles.dropdown}> */}
              {/* <select
                value={sortValue}
                onChange={(e) => setSortValue(e.target.value)}
                className={styles.select}
              > */}
                {/* <option value="latest">Latest</option>
                <option value="popularity">Popularity</option>
                <option value="average-rate">Average Rate</option> */}
                {/* <option value="high-to-low">High to Low</option>
                <option value="low-to-high">Low to High</option>
              </select> */}
               {/* <span className={styles.customArrow}></span> */}
            {/* </div> */}
            <ReviewTile reviews={[product]} />
          </div>
        )}
      </div>
    </div>
  );
};
const mapStateToProps = (state, props) => {
  return {
    reviews: state?.review?.reviews
  }
}
export default connect(mapStateToProps, null)(ReviewProductDetailsPage)
